/**
 * Custom background colors for the chat compose section
 */ export const CustomBackgroundColors = {
    backgroundColorWhite: {
        lightModeColor: "#ffffff",
        darkModeColor: "#333333"
    },
    backgroundColorKobiRed: {
        lightModeColor: "#df9299",
        darkModeColor: "#df9299"
    },
    backgroundColorRoseBud: {
        lightModeColor: "#f4a593",
        darkModeColor: "#f4a593"
    },
    backgroundColorGoldenrod: {
        lightModeColor: "#fdd472",
        darkModeColor: "#fdd472"
    },
    backgroundColorPrimrose: {
        lightModeColor: "#e5f18f",
        darkModeColor: "#e5f18f"
    },
    backgroundColorMantis: {
        lightModeColor: "#82cda8",
        darkModeColor: "#82cda8"
    },
    backgroundColorRegentBlue: {
        lightModeColor: "#9dd9db",
        darkModeColor: "#9dd9db"
    },
    backgroundColorPeriwinkleGray: {
        lightModeColor: "#c7d4e8",
        darkModeColor: "#c7d4e8"
    },
    backgroundColorPaleRose: {
        lightModeColor: "#ebd3e1",
        darkModeColor: "#ebd3e1"
    }
};
export const CustomBackgroundColorDropDownItems = {
    backgroundColorWhite: "White",
    backgroundColorKobiRed: "Kobi Red",
    backgroundColorRoseBud: "Rose Bud",
    backgroundColorGoldenrod: "Goldenrod",
    backgroundColorPrimrose: "Primrose",
    backgroundColorMantis: "Mantis",
    backgroundColorRegentBlue: "Regent St. Blue",
    backgroundColorPeriwinkleGray: "Periwinkle Gray",
    backgroundColorPaleRose: "Pale Rose"
};
/**
 * Get mode independent color value of custom background color from the given color key
 * @param key The key to get color from
 * @returns A mode independent color value of the given key
 */ export function getCustomBackgroundColorValue(key) {
    return CustomBackgroundColors[key] ?? CustomBackgroundColors.backgroundColorWhite;
}
